import { countBy, identity } from 'es-toolkit';
import { Vector3 } from 'three';

import { AnalogLink } from '@paragon/contract-library';

export const getPanelStartAndEndPoints = (links: AnalogLink[]) => {
  // Find joints at ends of panel (which should only appear once among the links)
  const joints = links.flatMap(({ iJoint, jJoint }) => [iJoint, jJoint]);
  const endJointGuids = Object.entries(
    countBy(
      joints.map(({ guid }) => guid),
      identity,
    ),
  )
    .filter(([, count]) => count === 1)
    .map(([jointGuid]) => jointGuid);
  if (endJointGuids.length !== 2) return null;
  const [start, end] = endJointGuids.map((jointGuid) => joints.find(({ guid }) => guid === jointGuid)!);

  return { start: new Vector3(start.x, start.y, start.z), end: new Vector3(end.x, end.y, end.z) };
};
